import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  OrganisationsListComponent,
  OrganisationFormComponent,
  OrganisationSettingsComponent,
  OrganisationControlPanelComponent
} from '../upgrade/organisations.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const organisationsRoutes: Routes = [
  {
    path: 'organisations',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      role: 'system:superadmin'
    },
    children: [
      {
        path: '',
        component: OrganisationsListComponent,
        data: {
          state: 'epf.organisations.index'
        }
      },
      {
        path: 'new',
        component: OrganisationFormComponent,
        data: {
          state: 'epf.organisations.new'
        },
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'settings/:orgId',
        component: OrganisationSettingsComponent,
        data: {
          state: 'epf.organisations.settings'
        },
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'control',
        component: TwoColumnsRightComponent,
        canActivate: [setupGuard],
        children: [
          {
            path: '',
            component: OrganisationControlPanelComponent,
            data: {
              state: 'epf.organisations.control'
            }
          }
        ]
      }
    ]
  }
];
